import { PromptTemplateCategory } from '../types';

export const educational: PromptTemplateCategory = {
  title: "교육적",
  icon: "🧠",
  templates: [
    {
      title: "쉽게 설명하기",
      content: `[백신이 면역 체계를 어떻게 훈련시키는지] 주제를 청취자에게 명확하고 흥미롭게 설명해 주세요.
- [과학 배경이 없는 호기심 많은 십대]에게 설명한다고 상상해 보세요.
- 친근한 비유를 사용해 주세요: [화재 대피 훈련에 비유 — 실제 상황에 대비해 연습하는 것].
- 전문 용어를 피하고, 기술 용어가 필요한 경우 즉시 쉬운 말로 정의해 주세요.
- 청취자가 똑똑하다고 느끼게 하는, 따뜻하고 격려하는 톤으로 작성해 주세요. 가르치려 드는 느낌이 아니라.`
    },
    {
      title: "다큐멘터리 내레이션",
      content: `다큐멘터리 스타일의 내레이션을 작성해 주세요.
- 주제: [방콕 길거리 음식 판매자들의 일상].
- 관점: [간단해 보이지만 숙달하는 데 수년이 걸리는 요리 뒤의 장인 정신, 자부심, 세대를 넘어 전해지는 지식].
- 톤: [존중하고, 생생하며, 서두르지 않는 — 장면이 숨 쉴 공간을 주세요].
- 청취자가 환경을 상상하고 느끼는 데 도움이 되는 감각적 묘사를 포함해 주세요: [웍의 지글거리는 소리, 아침 시장의 습기, 만 번을 해온 상인의 정확한 손동작].
- 생생함을 위해 현재 시제로 작성해 주세요.`
    },
    {
      title: "가이드 명상",
      content: `듣기 위해 설계된 가이드 명상 스크립트를 작성해 주세요.
- 목표: [긴 근무일 후의 긴장을 풀고 편안하게 저녁으로 전환하기].
- 청취자를 안내하여 상상하게 해 주세요 [해질녘의 고요한 호숫가 — 수면 위의 따뜻한 빛, 부드러운 바람, 밤을 맞아 자리 잡는 먼 곳의 새소리].
- 톤: [차분하고, 서두르지 않으며, 안정감 있는].
- 예상 발표 시간: [8분].
- 지시 사이에 충분한 자연스러운 쉼("..."으로 표시)을 사용해 주세요. 문장을 짧고 부드럽게 유지해 주세요. 에너지의 급격한 변화를 피해 주세요.`
    }
  ]
};
